'use client'
import React, { useEffect } from 'react'
import { AspectRatio, Box, HStack, Stack, Text } from '@chakra-ui/react'
import Image from 'next/image'
import { QuestionIcon } from '@/_assets/icon-components'
import { IProduct } from '@/entities/product/model/types'
import { useCustomLocale } from '@/_hooks/useCustomLocale'
import useEmblaCarousel from 'embla-carousel-react'

const Ingredients = ({ data }: { data?: IProduct }) => {
  const currentLocale = useCustomLocale()

  // useKeenSlider<HTMLDivElement>({
  //   mode: 'snap',
  //   dragSpeed: 0.8,
  //   slides: {
  //     origin: 'auto',
  //     perView: 4,
  //     spacing: 16,
  //   },
  //   breakpoints: {
  //     '(max-width: 1024px)': {
  //       slides: {
  //         perView: 4,
  //       },
  //     },
  //     '(max-width: 768px)': {
  //       slides: {
  //         origin: 'auto',
  //         spacing: 8,
  //         perView: 4,
  //       },
  //     },
  //   },
  // })

  if (data?.ingredients && data?.ingredients?.length > 0)
    return (
      <HStack overflowX="auto" gap={6} mt={{ base: 6, lg: 0 }} mb={4}>
        {data?.ingredients?.map((item, idx) => {
          const imageUrl = item?.image?.includes(process.env.BASE_URL!)
            ? item?.image
            : process.env.BASE_URL + item?.image

          return (
            <Stack align="center" key={item?.id + idx}>
              <Box position="relative" width="50px" height="50px">
                {item ? (
                  <Image
                    src={imageUrl}
                    priority={true}
                    style={{
                      objectFit: 'cover',
                    }}
                    alt={'banner'}
                    fill
                  />
                ) : (
                  <Box>
                    <QuestionIcon />
                  </Box>
                )}
              </Box>
              <Text fontSize={'xs'} textAlign="center">
                {item?.title?.[currentLocale]}
              </Text>
            </Stack>
          )
        })}
      </HStack>
    )

  return null
}

export default Ingredients
